import * as React from "react";
import {defineMessages, injectIntl} from "react-intl";
import {WithApi, WithApiProperties} from "../../common/util/WithApi";
import {DataRootList} from "./DataRootList";
import InjectedIntlProps = ReactIntl.InjectedIntlProps;

const DATA_ROOT_MESSAGES = defineMessages({
    header: {
        id: "studio.settings.data-roots-page.header",
        defaultMessage: "Data roots",
    },
       description: {
         id: "studio.settings.data-roots-page.description",
         defaultMessage: "Data roots are entry points where ERDAS APOLLO Studio looks for data. Every data root has a matching crawling job, which takes care of the discovery.",
       }
});

class DataRootsPageComponent extends React.Component<WithApiProperties & InjectedIntlProps, null> {
  constructor(props) {
    super(props);
  }

  render() {
    const {intl} = this.props;

    return (
        <div>
          <h1>
                    {intl.formatMessage(DATA_ROOT_MESSAGES.header)}
                </h1>
                <hr/>
                <p>
                    {intl.formatMessage(DATA_ROOT_MESSAGES.description)}
                </p>
                <div> {/* This empty div is necessary! it's used by ControlRoomTable to calculate its dimensions.*/}
                    <DataRootList className="user-tour-data-roots-list"/>
                </div>
            </div>
        );
    }
}

export const DataRootsPage = WithApi(injectIntl(DataRootsPageComponent));